// reactstrap components
import { NavItem, NavLink, Nav, Container, Row, Col } from "reactstrap";

const AdminFooter: React.FC = () => {
  return (
    <>
      <Container fluid>
        <footer className="footer pt-0">
          <Row className="align-items-center justify-content-lg-between">
            <Col lg="6">
              <div className="copyright text-center text-lg-left text-muted">
                © {new Date().getFullYear()}{" "}
                <a
                  className="font-weight-bold ml-1"
                  href="http://mixasian.com"
                  target="_blank"
                >
                  Mixasian.com
                </a>
              </div>
            </Col>
          </Row>
        </footer>
      </Container>
    </>
  );
};

export default AdminFooter;
